<script>
export default {
  props: {
    date: {
      type: [Date, String],
      required: true
    },
    options: {
        type: Object,
        required: false,
        default: () => ({
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        })
    }
  },
  computed: {
    formatted() {
        const date = typeof this.date === 'string'? new Date(Date.parse(this.date)) : this.date;
        return date.toLocaleDateString(undefined, this.options).replace(/\s/g,' ');
    }
  }
}
</script>
<template>
  <span>{{formatted}}</span>
</template>